import ModalTrigger from '@app/Triggers/ModalTrigger'
import MenuTrigger from '@app/Triggers/MenuTrigger'
import ConfirmModalTrigger from '@app/Triggers/ConfirmModalTrigger'

export default function install(Vue) {
  Vue.component('ModalTrigger', ModalTrigger)
  Vue.component('MenuTrigger', MenuTrigger)
  Vue.component('ConfirmModalTrigger', ConfirmModalTrigger)
}
